export default "<ngx-ui-loader></ngx-ui-loader>\n<div class=\"container-fluid\">\n  <app-header></app-header>\n  <router-outlet></router-outlet>\n</div>"